import { memo } from "react";
import Image from "next/image";
import StarImageUrl from "./assets/star.png";
import Star2ImageUrl from "./assets/star-2.png";
import { Audience as AudienceModel } from "../../../model/info-about-bootcamp";
import { getCourseStatus } from "../../../utils/course-utils";

interface Props {
  title: string;
  data: AudienceModel;
  id: string;
}

export const Audience = memo<Props>(({ data, title, id }) => {
  const { isOptimism } = getCourseStatus(id);

  return (
    <div className="pt-[72px] lg:pt-[140px]" id="for-whom">
      <div className="rounded-[16px] bg-dark-grey pl-4 pr-4 pb-4 pt-24 lg:pl-15 lg:pt-20 lg:pr-15 lg:pb-17">
        <div
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: title,
          }}
          className="text-center text-night-base-base-500 text-[16px] leading-[130%] lg:text-[18px] lg:leading-[132%]"
        />
        <h2
          className="pt-6 lg:pt-4 text-center text-white"
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: data.title,
          }}
        />
        <div className="lg:grid grid-cols-3 gap-x-[10px] pt-16 lg:pt-28 text-white">
          <div className="mb-4 lg:mb-0 rounded-[10px] bg-night-base-base-100 pt-25 pb-12 pl-12 pr-12 lg:pb-15 lg:pt-30 lg:pl-15 lg:pr-15">
            <div className="relative m-auto flex max-w-[185px] justify-center">
              <Image src={StarImageUrl} alt="Image of star" />
              <div className="absolute right-[-40px] top-[-15px] rounded-[38px] bg-lime pt-4 pb-4 pl-13 pr-13 text-black">
                New
              </div>
            </div>

            <div
              className="pt-35 leading-[23px]"
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: isOptimism
                  ? "Beginners who want to learn blockchain with a focus on social impact"
                  : data.list[0].description || "",
              }}
            />
          </div>
          <div className="mb-4 lg:mb-0 rounded-[10px] bg-night-base-base-100 pt-25 pb-12 pl-12 pr-12 lg:pb-15 lg:pt-30 lg:pl-15 lg:pr-15">
            <div className="relative m-auto flex max-w-[185px] justify-center">
              <Image src={Star2ImageUrl} alt="Image of star" />
              <div className="absolute right-[-40px] top-[-15px] rounded-[38px] bg-blue pt-4 pb-4 pl-13 pr-13 text-white">
                Pro
              </div>
            </div>

            <div
              className="pt-35 leading-[23px]"
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: isOptimism
                  ? "Devs eager to specialize in Optimism's L2 scaling solutions"
                  : data.list[1].description || "",
              }}
            />
          </div>
          <div className="grid grid-rows-3 gap-y-[8px] lg:gap-y-[10px]">
            <div
              className="rounded-[20px] bg-night-base-base-100 p-12 lg:pb-25 lg:pt-10 lg:pl-15 lg:pr-15"
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: isOptimism
                  ? "Frontend devs looking to transition into the Optimism ecosystem"
                  : data.list[2].description || "",
              }}
            />

            <div
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: isOptimism
                  ? "Startup teams focusing on building public goods projects"
                  : data.list[3].description || "",
              }}
              className="rounded-[20px] bg-night-base-base-100 p-12 lg:pb-25 lg:pt-10 lg:pl-15 lg:pr-15"
            />

            {data.list[4].description && (
              <div
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: isOptimism
                    ? "Anyone aiming to understand the mechanisms of RetroPGF"
                    : data.list[4].description || "",
                }}
                className="rounded-[20px] bg-night-base-base-100 p-12 lg:pb-25 lg:pt-10 lg:pl-15 lg:pr-15"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
